'use client';
import React from 'react';

import ResetPasswordForm from './ResetPasswordForm';
import sty from './styles/Auth.module.css';

interface Props {
  onClose: (path: string) => void;
  modalView?: boolean;
}

const ResetPassword = (props: Props) => {
  return (
    <div className={sty.container}>
      <div>
        <ResetPasswordForm
          onClose={() => props.onClose('forgot-password')}
          modalView={props.modalView}
        />
      </div>
    </div>
  );
};

export default ResetPassword;
